export default __webpack_public_path__ + "static/media/noun_crown dental_1661446.76807867.png";